<template>
  <v-tooltip v-bind="$attrs">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" small>{{icon}}</v-icon>
    </template>
    <span>
      <slot name="default"></slot>
    </span>
  </v-tooltip>
</template>

<script>
  import { mdiInformationOutline } from '@mdi/js';
  export default {
    data() {
      return {
        icon: mdiInformationOutline
      }
    },  
  }
</script>

<style lang="scss" scoped>

</style>
